// extracted by mini-css-extract-plugin
module.exports = {"footerActions":"createTemplateModal_footerActions__mB_HE"};